let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aoGCR")).then(() => parcelRequire('5ytLq'));